import {SignalType} from 'gabi-api-ts/v2/common/signals/signals';
import {PatientType} from 'gabi-api-ts/v2/patient/common/patient_common';
import { Patient } from 'gabi-api-ts/v2/patient/query/patient_query';

export enum GlobalContext {
    GABI = 1,
    HINSCOPE = 2,
}

type PatientContext = {
    // Patient's devices support events
    supportsEvents: boolean;

    // Patient monitoring is real time
    hasRealTimeMonitoring: boolean;

    // Patient monitoring is real time
    signals: Partial<Record<SignalType, boolean>>;
};

export const defaultPatientContext: PatientContext = {
    supportsEvents: true,
    hasRealTimeMonitoring: true,
    signals: {
        [SignalType.Signal_PR]: true,
        [SignalType.Signal_SPO2]: true,
        [SignalType.Signal_Actigraphy]: true,
    }
};

declare global {
    // eslint-disable-next-line no-var
    var ANALYTICS_GLOBAL_CONTEXT: string;
}

/**
 * This class handles the context around a patient based on the patient type, pathology and the associated devices
 * (e.g. is it RT monitoring ? Does the device support events ?)
 */
class PatientContextService_ {
    getGlobalContext(): GlobalContext {
        if (globalThis.ANALYTICS_GLOBAL_CONTEXT === 'hinscope') {
            return GlobalContext.HINSCOPE;
        }
        else {
            return GlobalContext.GABI;
        }
    }

    getPatientContext(patient?: Patient | null): PatientContext {
        if (!patient) {
            return defaultPatientContext;
        }

        const signals = (patient.patientType !== PatientType.Adult) ? {
            [SignalType.Signal_PR]: true,
            [SignalType.Signal_SPO2]: true,
            [SignalType.Signal_Actigraphy]: true,
        } : {
            [SignalType.Signal_PR]: true,
            [SignalType.Signal_SPO2]: true,
            [SignalType.Signal_BP_SYS]: true,
            [SignalType.Signal_BP_DIA]: true,
            [SignalType.NEWS2]: true,
        };

        return {
            supportsEvents: patient.patientType !== PatientType.Adult,
            hasRealTimeMonitoring: patient.patientType !== PatientType.Adult,
            signals: signals,
        };
    }
}

export const PatientContextService = new PatientContextService_();
